import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HelpersService } from './helpers.service';
import { Observable, map, catchError, of, first } from 'rxjs';
import { RoleService } from './role.service';
interface RoleDetails {
  roleClaims: string[]; // Adjust the type according to your actual data structure
}
@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  USER_PERMISSIONS: string = 'tems-user-permissions';
  private claimsCache: any[] | null = null;
  private claimsRequest: Promise<any> | null = null;

  constructor(
    private helpers: HelpersService,
    private roleService: RoleService,
    private authService: AuthService
  ) {
    this.authService.authEvents$.subscribe(() => this.resetClaimsCache());
  }
  getAllPermissions(): Observable<string[]> {
    return this.roleService.roleDetails(this.helpers.role_id()).pipe(
      map((role: any) => role?.roleClaims ?? []),
      catchError((err) => of([])) // Handle errors gracefully
    );
  }
  async getAllClaims() {
    if (this.claimsCache) {
      return this.claimsCache;
    }
    if (this.claimsRequest) {
      return this.claimsRequest;
    }
    this.claimsRequest = (async () => {
      try {
        const res = await this.getAllPermissions().pipe(first()).toPromise();
        this.claimsCache = res ?? [];
        return this.claimsCache;
      } catch (error) {
        console.error('Error fetching claims:', error);
        return [];
      } finally {
        this.claimsRequest = null;
      }
    })();
    return this.claimsRequest;
  }
  
  resetClaimsCache() {
    this.claimsCache = null;
    this.claimsRequest = null;
  }

  hasPermission(claims: any[], permissionType: string | string[]): boolean {
    // Iterate through the claims to find a match for any of the requested permissionType(s)
    const permissionTypes = Array.isArray(permissionType)
      ? permissionType
      : [permissionType];
    for (const claim of claims) {
      if (permissionTypes.includes(claim.claimType)) {
        return true; // Permission found
      }
    }
    return false; // No matching permission found
  }
}
